





































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";

import { MathHelper } from "@/helper/mathHelper";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LineStartController extends Vue 
{
    @Prop() layer! : LineLayer;

    private isValue(value : number)
    {
        return this.layer.startType == value;
    }

    private setValue(value : number)
    {
        this.changeLayerProperty("startType", value, true, true);
    }

    private get startWidth()
    {
        return MathHelper.clamp(this.layer.startWidth, -20, 20);
    }

    private set startWidth(startWidth)
    {
        this.changeLayerProperty("startWidth", Number(startWidth), false, false);
    }

    private onStartWidthChanged()
    {
        this.changeLayerProperty("startWidth", this.startWidth, true, false);
    }

    private get startWidthText()
    {
        return this.startWidth.toFixed(1) + "mm";
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
